export enum OnboardingStatus {
  Onboarding = 'Onboarding',
  Completed = 'Completed',
}

export interface OnboardingStatusReadModel {
  status: OnboardingStatus;
}
